import { defineMessages } from 'react-intl';

export default defineMessages({
  rental: {
    id: 'src.pages.Enterprise.rental',
    defaultMessage: 'Enterprise rental',
  },
  howItWorks: {
    id: 'src.pages.Enterprise.howItWorks',
    defaultMessage: 'How it works:',
  },
  list1: {
    id: 'src.pages.Enterprise.list1',
    defaultMessage: 'Your address will prepopulate below to find Enterprise locations near you. Or you can type in your preferred address.',
  },
  list2: {
    id: 'src.pages.Enterprise.list2',
    defaultMessage: 'Choose a location near you to book your rental reservation.',
  },
  list3: {
    id: 'src.pages.Enterprise.list3',
    defaultMessage: 'Provide your email address and Enterprise will contact you with next steps.',
  },
  locationNearMe: {
    id: 'src.pages.Enterprise.locationNearMe',
    defaultMessage: 'Find location near me',
  },
  addressPlaceholder: {
    id: 'src.pages.Enterprise.addressPlaceholder',
    defaultMessage: 'Address',
  },
  closestLocation: {
    id: 'src.pages.Enterprise.closestLocation',
    defaultMessage: 'Your closest locations:',
  },
  viewMap: {
    id: 'src.pages.Enterprise.viewMap',
    defaultMessage: 'View map',
  },
  emailPlaceholder: {
    id: 'src.pages.Enterprise.emailPlaceholder',
    defaultMessage: '[email account on policy]',
  },
  headsup: {
    id: 'src.pages.Enterprise.headsup',
    defaultMessage: 'Heads up!',
  },
  headsupSubtext: {
    id: 'src.pages.Enterprise.headsupSubtext',
    defaultMessage: 'You aren’t covered for gas, mileage, environmental fees, tickets, toll highway fees, or optional insurance. The insurance on your own vehicle will transfer over to the rental temporarily while your vehicle is out of service. If you choose to purchase additional insurance, it’ll be at your own cost.',
  },
  getReady: {
    id: 'src.pages.Enterprise.getReady',
    defaultMessage: 'Get ready to ride',
  },
  continueCta: {
    id: 'src.pages.Enterprise.continueCta',
    defaultMessage: 'Continue',
  },
  saveContinueCta: {
    id: 'src.pages.Enterprise.saveContinueCta',
    defaultMessage: 'Save & continue later',
  },
  pickLocationCta: {
    id: 'src.pages.Enterprise.pickLocationCta',
    defaultMessage: 'Pick a different location',
  },
  schedule: {
    id: 'src.pages.Enterprise.schedule',
    defaultMessage: 'Schedule your Enterprise rental',
  },
  reservationTitle: {
    id: 'src.pages.Enterprise.reservationTitle',
    defaultMessage: 'Your rental reservation:',
  },
  emailAddress: {
    id: 'src.pages.Enterprise.emailAddress',
    defaultMessage: 'Please provide your email so Enterprise can contact you with more detail for your reservation:',
  },
  emailAddressErrorMessage: {
    id: 'src.pages.Enterprise.emailAddressErrorMessage',
    defaultMessage: 'Oops! Your email needs to contain an "@" and a ".".',
  },
  reviewHeading: {
    id: 'src.pages.Enterprise.reviewHeading',
    defaultMessage: 'Your rental request',
  },
  reviewIntroContinue: {
    id: 'src.pages.Enterprise.reviewIntroContinue',
    defaultMessage: '‘Continue’',
  },
  reviewIntroFirstPart: {
    id: 'src.pages.Enterprise.reviewIntroFirstPart',
    defaultMessage: 'Once you click',
  },
  reviewIntroSecondPart: {
    id: 'src.pages.Enterprise.reviewIntroSecondPart',
    defaultMessage: 'your rental reservation will be sent to Enterprise.',
  },
  reviewTitle: {
    id: 'src.pages.Enterprise.reviewTitle',
    defaultMessage: 'You’ve requested a rental from:',
  },
  reviewNextSteps: {
    id: 'src.pages.Enterprise.reviewNextSteps',
    defaultMessage: 'Next steps:',
  },
  reviewListInto: {
    id: 'src.pages.Enterprise.reviewListInto',
    defaultMessage: 'Enterprise will email you with a confirmation.',
  },
  reviewListInto1: {
    id: 'src.pages.Enterprise.reviewListInto1',
    defaultMessage: 'Once your rental is confirmed, Enterprise will:',
  },
  reviewList1: {
    id: 'src.pages.Enterprise.reviewList1',
    defaultMessage: 'Ask for your vehicle’s repair date. (If you don’t have this right away, call Enterprise to provide it when available)',
  },
  reviewList2: {
    id: 'src.pages.Enterprise.reviewList2',
    defaultMessage: 'Arrange to pick you up',
  },
  reviewList3: {
    id: 'src.pages.Enterprise.reviewList3',
    defaultMessage: 'Sort out the deposit',
  },
  reviewList4: {
    id: 'src.pages.Enterprise.reviewList4',
    defaultMessage: 'Do a walkaround of your rental vehicle',
  },
  reviewList5: {
    id: 'src.pages.Enterprise.reviewList5',
    defaultMessage: 'Have you sign the rental agreement and get you on your way',
  },
  requiredErrorMessage: {
    id: 'src.pages.Enterprise.requiredErrorMessage',
    defaultMessage: 'Oops! Looks like you forgot to fill this in.',
  },
  branchName: {
    id: 'src.pages.Enterprise.branchName',
    defaultMessage: 'Branch name',
  },
  noLocationsError1: {
    id: 'src.pages.Enterprise.noLocationsError1',
    defaultMessage: 'Uh oh! Something went wrong. Please try again or give us a call at ',
  },
  noLocationsError2: {
    id: 'src.pages.Enterprise.noLocationsError2',
    defaultMessage: '1-844-766-6384',
  },
  noLocationsError3: {
    id: 'src.pages.Enterprise.noLocationsError3',
    defaultMessage: '. You can also continue with your claim and a Claims team member will arrange this for you later.',
  },
});
